import PropTypes from "prop-types";
import React from "react";
import PlaylistSelectionModal from "../components/PlaylistSelectionModal";
import PlaylistConversionModal from "../components/PlaylistConversionModal";
import PlaylistConversionFilterModal from "../components/PlaylistConversionFilterModal";
import PlaylistSelection from "../components/PlaylistSelection";
import TracksTable from "../components/TracksTable";
import GoogleScript from "../components/GoogleScript";
import FaYoutube from "react-icons/lib/fa/youtube";

import { handleSpotifyAuthCallback, isSpotifyAccessTokenValid } from '../lib/spotify-auth';
import { handleAuthClick, handleSignoutClick } from '../lib/youtube-auth';
import { getChannel, getPlaylists, searchYoutube, createPlaylist, insertIntoPlaylist } from '../lib/youtube-api';
import { addAllToPlaylist } from '../lib/youtube-converter';
import { getGoogleApi } from "../lib/window";
import { getMe, getMyPlaylists, getPlaylistTracks } from '../lib/spotify-api';

class Converter extends React.Component {
  constructor() {
    super();

    this.state = {
      playlists: [],
      activePlaylistId: '',
      activePlaylistName: '',
      activePlaylistSongs: [],
      activePlaylistSongCount: 0,
      activePlaylistLoading: false,
      activePlaylistOwnerId: '',
      spotifyDisplayName: [],
      youtubeClientLoaded: false,
      youtubeSignedIn: false,
      youtubeChannel: null,
    }

    this.loadPlaylist = this.loadPlaylist.bind(this);
    this.noPlaylist = this.noPlaylist.bind(this);
    this.handleYoutubeClientLoad = this.handleYoutubeClientLoad.bind(this);
    this.updateSignInStatus = this.updateSignInStatus.bind(this);
  }

  loadPlaylist({ playlistId, playlistName, songCount, ownerId }) {
    if (this.state.activePlaylistLoading) {
      // Implement cancel loading so we don't have to do this...
      alert('Spotify playlist songs are loading. Please wait for that to finish or refresh the page to select a new playlist.');
      return;
    }

    this.setState({
      activePlaylistId: playlistId,
      activePlaylistName: playlistName,
      activePlaylistSongCount: songCount,
      activePlaylistLoading: true,
      activePlaylistOwnerId: ownerId,
    });

    getPlaylistTracks({ ownerId, playlistId }).then((response) => {
      this.setState({
        activePlaylistLoading: false,
        activePlaylistSongs: response.tracks
      });
    });
  }

  updateSignInStatus(signedIn) {
    this.setState({ youtubeSignedIn: signedIn });

    if (signedIn) {
      getChannel().then((response) => {
        if (response) {
          this.setState({
            youtubeChannel: response
          })
        }
      });
    } else {
      this.setState({
        youtubeChannel: null
      });
    }
  }

  handleYoutubeClientLoad({ youtubeClientLoaded }) {
    this.setState({ youtubeClientLoaded });

    if (youtubeClientLoaded) {
      const googleApi = getGoogleApi();

      googleApi.auth2.getAuthInstance().isSignedIn.listen(this.updateSignInStatus); // Listen for sign-in state changes.
      this.updateSignInStatus(googleApi.auth2.getAuthInstance().isSignedIn.get()); // Handle the initial sign-in state.
    }
  }

  noPlaylist() {
    this.setState({
      activePlaylistId: '',
      activePlaylistName: 'No Playlists Available - Please add playlists and refresh the page',
      activePlaylistSongCount: 0,
      activePlaylistLoading: false,
      activePlaylistOwnerId: '',
    });
  }

  componentDidMount() {
    getMe().then((response) => {
      const spotifyDisplayName = response ? response.display_name : '';
      spotifyDisplayName && this.setState({ spotifyDisplayName });
    });

    getMyPlaylists().then((response) => {
      const playlists = response.playlists;
      this.setState({ playlists });

      if (playlists.length > 0) {
        const firstPlaylist = playlists[0];
        const { playlistId, playlistName, songCount, ownerId } = firstPlaylist;
        this.loadPlaylist({ playlistId, playlistName, songCount, ownerId });
      } else {
        noPlaylist();
      }
    });
  }

  render() {
    const {
      playlists, activePlaylistId, activePlaylistName, activePlaylistSongs, spotifyDisplayName,
      youtubeClientLoaded, youtubeSignedIn, youtubeChannel, activePlaylistSongCount,
      activePlaylistLoading, activePlaylistOwnerId
    } = this.state;

    return (
      <React.Fragment>
        <GoogleScript handleYoutubeClientLoad={this.handleYoutubeClientLoad} />
        <div className="flex-grid">
          <div className="col-t t_25 _20">
            <div>
              <PlaylistSelection playlists={playlists} onClickPlaylist={this.loadPlaylist} activePlaylistId={activePlaylistId} spotifyDisplayName={spotifyDisplayName} />
            </div>
          </div>
          <div className="p_100 t_75 _55">
            <div className="convert-table-head">
              <div>
                {activePlaylistLoading && <span><h2>{activePlaylistName}</h2> - Loading {activePlaylistSongCount} Songs...</span>}
                {!activePlaylistLoading && <span><h2>{activePlaylistName}</h2> by {activePlaylistOwnerId} - {activePlaylistSongCount} Songs (250 Max)</span>}
                <PlaylistSelectionModal playlists={playlists} onClickPlaylist={this.loadPlaylist} activePlaylistId={activePlaylistId} spotifyDisplayName={spotifyDisplayName} />
              </div>
              <div className="youtube-head">
                {youtubeClientLoaded && !youtubeSignedIn &&
                  <button className="youtube md" onClick={ handleAuthClick }>Sign in YouTube</button>
                }
                {youtubeSignedIn &&
                  <button className="youtube md" onClick={ handleSignoutClick }>Logout - {youtubeChannel && youtubeChannel.channelName}</button>
                }
                <PlaylistConversionFilterModal canConvert={youtubeSignedIn} />
                <PlaylistConversionModal canConvert={youtubeSignedIn} title={activePlaylistName} songs={activePlaylistSongs} />
              </div>
            </div>
            <TracksTable
              songs={activePlaylistSongs}
              onClickSong={() => {}}
              activePlaylistLoading={activePlaylistLoading}
            />
          </div>
          <div className="col-d _25 look-here-section">
            <a target="_blank" href="https://www.tunemymusic.com/YouTube-to-Spotify.php">Convert YouTube to Spotify</a><br />
            <a target="_blank" href="/airbnb-credit/">$55 free</a><br />
            <a target="_blank" href="http://youtube.com/c/shervinater">Learn about Smart Health Technology / Biohacking, subscribe to my friend's YouTube</a><br />
            {/*<a target="_blank" href="https://www.amazon.com/gp/product/B00V9Z2WBK/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00V9Z2WBK&linkCode=as2&tag=santabarbar0a-20&linkId=7ea2b55262c2a97481e817412aaee40a"><img border={0} src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B00V9Z2WBK&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=santabarbar0a-20" /></a><img src="//ir-na.amazon-adsystem.com/e/ir?t=santabarbar0a-20&l=am2&o=1&a=B00V9Z2WBK" width={1} height={1} border={0} alt style={{'border': 'none !important', 'margin': '0px !important'}} />*/}
            {/*<a target="_blank" href="https://www.amazon.com/gp/product/B00V9Z2VXE/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00V9Z2VXE&linkCode=as2&tag=santabarbar0a-20&linkId=508ecfef9773eb7b3fc7ef23baf216be"><img border={0} src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B00V9Z2VXE&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=santabarbar0a-20" /></a><img src="//ir-na.amazon-adsystem.com/e/ir?t=santabarbar0a-20&l=am2&o=1&a=B00V9Z2VXE" width={1} height={1} border={0} alt style={{border: 'none !important', margin: '0px !important'}} />*/}
            {/*<a target="_blank" href="https://www.youtube.com/channel/UCNnkp6SwIbCXXOmXZzoDEJA?sub_confirmation=1"><h5>Follow Playlist Buddy on YouTube</h5></a>*/}
            {/*<a target="_blank" href="https://www.youtube.com/watch?v=aJOTlE1K90k&list=PLjK-ed2t5FXrkE5Zw1WkQOEvc0_rQUYo_"><h2>Top 10 - June 2018</h2></a>*/}
            {/*<a target="_blank" href="https://www.youtube.com/watch?v=tvTRZJ-4EyI&index=1&list=PLjK-ed2t5FXq3avZKhGTGEd6yJkGL2XHK"><h2>Global Top 50</h2></a>*/}
            {/*<a target="_blank" href="https://www.youtube.com/watch?v=eimgRedLkkU&list=PLjK-ed2t5FXr7zPLoBTxv2XGhn8Y76IYI&index=1"><h2>Summer Playlist</h2></a>*/}
            {/*<a target="_blank" href="https://www.youtube.com/watch?v=RYzQvj3icjs&list=PLjK-ed2t5FXquuM0Doq7D7-jVRRoiOH8r&index=1"><h2>Sunday Funday</h2></a>*/}
            {/*<a target="_blank" href="https://www.youtube.com/watch?v=gEPmA3USJdI&list=PLjK-ed2t5FXpdFk70XrMpoUrW1N2inQ6x"><h2>AC/DC Live</h2></a>*/}
          </div>
        </div>
        <style jsx>{`
          .flex-grid {
            margin-left: 2vw;
            width: 98vw;
            display: flex;
            flex-direction: row;
            max-height: 80vh;
            min-height: 80vh;
            margin-bottom: 5vh;

            > div {
              padding: 0px 15px;
            }

            .col-d, .col-t {
              display: none;
            }
          }

          button {
            border: 0;
            cursor: pointer;
            font-size: 16px;
            min-width: 100px;
            margin-bottom: 15px;
          }

          button.md {
            border-radius: 5px;
            // font-size: px;
            padding: 10px 15px;
          }

          button.youtube {
            background: red;
            color: white;
            // border-radius: 50px;
            // max-width: 100vw;
            // min-height: 60px;
            margin-left: 20px;
          }

          .convert-table-head {
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
          }

          .look-here-section {
            display: flex;
            justify-content: center;
            flex-direction: column;

            a {
              margin-bottom: 15px;
              padding: 20px;
            }

            a:hover {
              color: #346294;
            }
          }

          .youtube-head {
            display: flex;
            justify-content: flex-end;
          }

          @from-width desktop {
            .flex-grid {
              margin-top: 100px;

              .col-d {
                display: flex;
              }
            }

            .convert-table-head {
              display: flex;
              justify-content: space-between;
              flex-direction: row;
            }
          }

          @from-width tablet {
            .flex-grid {
              .col-t {
                display: flex;
              }
            }
          }

          .p_100 {
            flex: 10;
          }

          .col-t {
            .t_25 {
              flex: 2.5;
            }

            .t_75 {
              flex: 7.5;
            }
          }

          ._15 {
            flex: 1.5;
          }
          ._25 {
            flex: 2.5;
          }
          ._55 {
            flex: 5.5;
          }
          ._20 {
            flex: 2;
          }

        `}</style>
      </React.Fragment>
    );
  }
}

export default Converter;



// WEBPACK FOOTER //
// ./src/pages/converter.js